{
	"backToManageDeclarations": "Zurück zu Erklärungen verwalten"
}
